// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"36":"f934fae3","67":"c53235fc","711":"601abd4a"}[chunkId] + ".chunk.js";
};